import { StandardEvents } from '@shopify/events';

// Use Ritual's own cart event so the count also follows native product and drawer updates.
document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  event.promise?.then(({ cart, detail }) => {
    const count = cart?.totalQuantity ?? detail?.itemCount;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-mk-cart-count]').forEach((el) => { el.textContent = String(count); });
  }).catch(() => { /* Native cart components display any cart error. */ });
});

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.mk-mobile-nav a');
  if (link) link.closest('details').open = false;
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mk-mobile-nav[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary')?.focus();
  });
});
